import * as Yup from 'yup';

import { MAX_FILE_SIZE_30MB } from '@/common/constants';

export const updateInspectionProcessSchema = () => {
    return (
        Yup.object({
            actualInspectionDate: Yup.date()
                .required('Actual inspection date is required'),
            inspector: Yup.string()
                .required('Inspector is required'),
            country: Yup.string()
                .trim()
                .required('Country is required'),
            port: Yup.string()
                .required('Port is required'),
            vesselName: Yup.string()
                .required('Vessel name is required'),
            type: Yup.string()
                .required('Type is required'),
            inspectionResult: Yup.mixed()
                .test('fileSize', 'File size is too large', (value: any) => {
                    if (value && (value as File).size > MAX_FILE_SIZE_30MB) {
                        return false;
                    }

                    return true;
                })
                .required('Inspection result file is required')
        }));
}
